import api from './api';
import { unwrapApiResponse, ApiResponse } from '@/utils/api-response.util';
import {
  ClientExpertPostDetail,
  ClientExpertPostListItem,
  ClientExpertPostsListResponse,
} from '@/types/expert-posts';

export const expertPostsClientService = {
  async getPosts(page = 1, limit = 10): Promise<ClientExpertPostsListResponse> {
    const response = await api.get<ApiResponse<ClientExpertPostListItem[]>>('/expert-posts', {
      params: { page, limit },
    });
    return { data: response.data.data, meta: response.data.meta };
  },

  async getPost(id: number): Promise<ClientExpertPostDetail> {
    const response = await api.get(`/expert-posts/${id}`);
    return unwrapApiResponse<ClientExpertPostDetail>(response);
  },

  async markAllRead(): Promise<void> {
    await api.post('/expert-posts/mark-all-read');
  },
};
